"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopShortcut = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const PhotoshopShortcutSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    clipPath: "url(#photoshop-shortcut__a)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#001E36",
      fillRule: "evenodd",
      d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
      clipRule: "evenodd"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#31A8FF",
      fillRule: "evenodd",
      d: "M9.673 13.294c1.789-.217 2.94-1.348 2.94-3.147 0-2.121-1.631-3.27-3.815-3.27H5.207v2.71c.605.232 1.18.527 1.715.877V8.221H8.93c1.183 0 2.065.665 2.065 1.827 0 1.14-.834 1.918-2.016 1.918h-.301q.556.616.994 1.327m9.757 1.627c0 1.4-1.14 2.219-2.925 2.219-1.512 0-2.905-.7-3.143-2.338h1.498c.189.805.91 1.134 1.637 1.134.869 0 1.45-.294 1.45-.917 0-.455-.28-.714-.938-.854l-1.373-.315c-1.231-.273-2.03-.854-2.036-1.995-.008-1.288.994-2.233 2.905-2.233 1.687 0 2.786.777 2.82 2.17h-1.448c-.105-.623-.61-.994-1.386-.994-.806 0-1.373.308-1.373.938 0 .44.386.672 1.176.84l1.302.315c1.485.37 1.834 1.35 1.834 2.03",
      clipRule: "evenodd"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "currentColor",
      d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "photoshop-shortcut__a",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
const PhotoshopShortcut = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: PhotoshopShortcutSvg
}));
exports.PhotoshopShortcut = PhotoshopShortcut;